/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import type { ReactNode } from "react";
import { Flags as BaseFlags } from "@superweb/flags";

const testingOnly = import.meta.env.FLEET_FORMS_ENV === "testing";

export const Flags = ({ children }: { children: ReactNode }) => {
  const showSingleDownloadButton = testingOnly;
  const newApiEnabled = true;

  return (
    <BaseFlags
      value={{
        "7fd41e03-8f0f-4153-b9ed-a0e613ed5500": Boolean(
          import.meta.env["FLEET_FORMS_VEHICLE_TYPES"],
        ),
        "389e962c-db8b-4c6b-bea1-9cc332e7d680": newApiEnabled,
        "cc53b6a9-88ef-4988-ba2c-36433e93fc01": newApiEnabled,
        "280f006d-a58a-40ad-bb83-ddb6fc333258": newApiEnabled,
        "3ca67208-2af6-4e4c-8440-e877540b1332": newApiEnabled,
        "aa814bf7-a087-4378-934f-9374140551cf": testingOnly,
        "39102927-6a29-4430-9740-f9f54697ca6b": testingOnly,
        "54b9dc94-8033-49da-85e0-f02af3de7072": testingOnly,
        "981627bb-163a-4c31-80c2-5a8ab8585967": showSingleDownloadButton,
        "ea22a0b5-1ea4-45b0-bdd1-b490a82fbb41": showSingleDownloadButton,
      }}
    >
      {children}
    </BaseFlags>
  );
};
